// extracted by mini-css-extract-plugin
module.exports = {"avatarWrap":"_0knEY5RzGmccd3mJ3s5mzg==","avatar":"xE6hthnGXQt4Cizlqu-Z6A=="};